import { Component, Input, SimpleChanges, OnChanges, Output, EventEmitter } from '@angular/core';
import { FbTeamMembersDashboardCardService } from './fb-team-members-dashboard-card.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-fb-team-members-dashboard-card',
  templateUrl: './fb-team-members-dashboard-card.component.html',
  styleUrls: ['./fb-team-members-dashboard-card.component.scss']
})
export class FbTeamMembersDashboardCardComponent implements OnChanges {
  @Input() content: {
    type: string,
    title: string,
    footerLink: string
  };
  teamMembers: any[];
  teamMembersCount: any;
  @Output() teamMembersCountChange = new EventEmitter<number>();

  constructor(
    private fbTeamMembersDashboardCardService: FbTeamMembersDashboardCardService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.content && this.content) {
      this.fetchTeamMembers();
    }
  }

  private fetchTeamMembers(): void {
    this.fbTeamMembersDashboardCardService.getTeamMembers()
      .pipe(take(1))
      .subscribe((teamMembers: any[]) => {
        this.teamMembersCount = teamMembers.length;
        this.teamMembersCountChange.emit(this.teamMembersCount);
        this.teamMembers = teamMembers.map(x => {
          const profilePicBase64 = x['smallProfilePic'];
          return {
            ...x,
            profilePicBase64: profilePicBase64
            ? `data:image/jpeg;base64,${profilePicBase64}`
            : null
          }
        });
      });
  }

}
